// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixLocation from 'wix-location';

// import {sendEmail} from 'backend/sendEmail.jsw';
$w.onReady(function () {
  // console.log($w("#repeater6").data);
	// $w("#button1").onClick( (event) => {
  //   let $item = $w.at(event.context);
  //   let selectedProduct = $item("#dataset3").getCurrentItem();
  //   let productId = selectedProduct._id;

  //   $w("#shoppingCartIcon1").addToCart(productId)
  //   .then( () => {
  //       console.log("Product added");
  //     } )
  //     .catch( (error) => {
  //       console.log(error);
  //     } );
  // } );

  //  $w("#image53").onClick( (event) => {
      
  //   let $item = $w.at(event.context);
  //   let selectedProduct = $item("#dataset3").getCurrentItem();
  //   let productId = selectedProduct._id;

  //   console.log(productId);
  //   wixData.queryReferenced("Stores/Products", productId, "collections").then(x => {
  //       console.log(x.items[0]['link-collections-name']);
  //       wixLocation.to(x.items[0]['link-collections-name']);
  //   });
    

    // wixLocation.to(selectedProduct.DynShopPage);

  //   wixData.query("Stores/Collections")
  //   .find()
  //   .then( (results) => {
  //     if(results.items.length > 0) {
        
  //       results.items.forEach(element => {
          
  //         if(element._id != "00000000-000000-000000-000000000001" ){

  //           console.log(element._id);
            
  //           wixData.queryReferenced("Stores/Products", productId, "collections").then(x => {
  //               console.log(x.items);
  //           });



  //         }
  //       });
          
        
  //     } else {
  //       // handle case where no matching items found
  //     }
  //   } )
  //   .catch( (err) => {
  //     let errorMsg = err;
  //   } );
  
  // });


});


//https://www.wix.com/velo/forum/coding-with-velo/how-to-get-collection-assigned-to-a-product-in-stores-products
//https://www.wix.com/velo/reference/$w/productpage/getproduct
//https://support.wix.com/en/article/velo-wix-stores-products-collection-fields#collections-collections
//https://www.wix.com/velo/reference/$w/repeater/data


/**
 *	商品一覧Repeaterが生成された時
 *	 @param {$w.$w} $item,
 *	 @param {Object} itemData,
 *	 @param {Number} index
 */
export function repeater11_itemReady($item, itemData, index) {
  // 商品詳細説明末尾の送料用情報を空白に書き換える
  // console.log(itemData.description);
	let regex = /###.*この行から下は送料計算に利用します。購入者には表示されません。.*###.*/i;
  $item("#text86").html = itemData.description.replace(regex, "");

  // ショップリンク生成
  wixData.query("Stores/Products")
  .eq('_id', itemData._id)
  .include("collections")
  .find().then(x => {
    let collections = x.items[0].collections;
    collections.forEach(shop => {
      if(shop.name != "イチオシ"){
        // console.log(encodeURI("/collections/" + shop.name));
        $item("#button13").link = encodeURI("/collections/" + shop.name);
      }
    });
  });
}